import React from "react";
import { useState } from "react";
import { BiShuffle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { message } from "antd";
import { ActionCodes } from "../../constants/ActionCodes";

import { randomPasswordGenerator } from "../../functions";
import { CREATE_USER_MUTATION } from "../../GraphQl/Mutations";
import { roles } from "../../constants/Roles";
import Loader from "../../components/Loader";

const CreateAdmin = () => {
  const [userDetail, setUserDetail] = useState({
    fullName: "",
    email: "",
    password: "",
  });
  const [msg, setMessage] = useState("");
  const [trial, setTrial] = useState(false);
  const [createNewUser, { loading, data, error }] = useMutation(
    CREATE_USER_MUTATION,
    {
      variables: {
        userDataInput: {
          fullName: userDetail.fullName,
          email: userDetail.email,
          password: userDetail.password,
          userType: roles.ADMIN,
        },
      },
      onCompleted: (data) => {
        setMessage(ActionCodes.S_001);
        success("Created Admin successfully");
      },
      onError: (e) => {
        err(e.message);
        setMessage(ActionCodes.S_001_0);
      },
    }
  );
  const navigate = useNavigate();
  const handleRegister = () => {
    let fullName = document.getElementById("fullName").value;
    let email = document.getElementById("email").value;
    let password = document.getElementById("password").value;

    setMessage("Enter all details");
    if (fullName != "" || email != "" || password != "") {
      setMessage("");
      setUserDetail({ fullName: fullName, email: email, password: password });
      createNewUser();
    }
    // navigate("/login");
  };
  const [messageApi, contextHolder] = message.useMessage();
  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const err = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };
  const generatePassword = () => {
    setUserDetail({ ...userDetail, password: randomPasswordGenerator() });
  };

  return (
    <section className='sectionWrapper createAdminWrapper'>
      {contextHolder}
      <div className='sectionHeaderTitle flex-col'>
        <div className='sectionHeaderTitle'>Create New Admin</div>
      </div>
      <div className='sectionContentWrapper'>
        <div className='createAdminFormWrapper'>
          <div className='inputGroup flex items-center'>
            <div className='label'>Full name</div>
            <input
              type='text'
              className='form-control'
              placeholder={"Enter full name"}
              onKeyUp={(e) =>
                setUserDetail({
                  ...userDetail,
                  fullName: e.target.value,
                })
              }
              id='fullName'
            />
          </div>
          <div className='inputGroup flex items-center'>
            <div className='label'>Email</div>
            <input
              type='text'
              className='form-control'
              placeholder={"Enter Email"}
              onKeyUp={(e) =>
                setUserDetail({
                  ...userDetail,
                  email: e.target.value,
                })
              }
              id='email'
            />
          </div>
          <div className='inputGroup flex items-center'>
            <div className='label'>Password</div>
            <div className='flex items-center justify-between w-100'>
              <input
                type='text'
                className='form-control'
                style={{ width: "85%" }}
                placeholder={"Enter Password"}
                defaultValue={userDetail?.password}
                value={userDetail?.password}
                onChange={(e) =>
                  setUserDetail({
                    ...userDetail,
                    password: e.target.value,
                  })
                }
                id='password'
              />
            </div>
            <div
              className='btn btn-secondary flex items-center justify-center'
              onClick={generatePassword}
              style={{ width: "15%" }}
            >
              <BiShuffle />
            </div>
          </div>
          <div
            className='btn btn-primary saveBtn col-12 col-md-6'
            onClick={handleRegister}
          >
            {loading && (
              <>
                <Loader color='#fff' /> &nbsp;
              </>
            )}
            Create Admin
            {/* <Loader color='#fff' /> Create Admin */}
          </div>
          {/* <div className='errMessage'>{message}</div> */}
        </div>
      </div>
    </section>
  );
};

export default CreateAdmin;
